import {SaveIcon as CheckitSaveIcon} from '@checkit/react-components/build/components/Icons';
import { CircularProgress, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

interface Props {
  formSubmitting: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  leftIcon: {
    marginRight: theme.spacing(1)
  }
}));

export const SaveIcon = ({formSubmitting}: Props) => {
  const classes = useStyles();

  return (
    formSubmitting ?
      <CircularProgress className={clsx(classes.leftIcon)} color="inherit" size={12}/>
        : <CheckitSaveIcon className={clsx(classes.leftIcon)} color="inherit"/>
  );
};
